module.exports = __webpack_public_path__ + "1.0.0-fa265927/img/online-collector-3.3d440c03.svg";